import { render } from "./Reception.vue?vue&type=template&id=2fcab8b8"
import script from "./Reception.vue?vue&type=script&lang=js"
export * from "./Reception.vue?vue&type=script&lang=js"

import "./Reception.vue?vue&type=style&index=0&id=2fcab8b8&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__